export default __webpack_public_path__ + "static/media/manar.b8e69eab.svg";